import type { StampId } from "./ids";

/** passport_service.award_stamps 실측 7종. */
export const STAMP_RULE_TYPES = [
  "FIRST_VISIT", "PLACE_COUNT", "REGION_COUNT", "TAG_COUNT",
  "MONTH_COUNT", "OFFICIAL_EVENT", "EXPLORER",
] as const;
export type StampRuleType = (typeof STAMP_RULE_TYPES)[number];

/** serialize_stamp 실측 형태. */
export interface Stamp {
  id: StampId;
  code: string;
  name: string;
  description?: string | null;
  imageKey?: string | null;
  ruleType: StampRuleType | string;
  awardedAt?: string | null;
  revoked: boolean;
}

/** POST /visits · /visits/checkins 응답의 STAMP Motion 트리거. */
export interface AwardedStamp { code: string; name: string }

/** I-ST-03: 회수된 스탬프는 여권에서 제외한다. */
export function isHeld(s: Pick<Stamp, "revoked" | "awardedAt">): boolean {
  return !s.revoked && !!s.awardedAt;
}
